import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { OfficeLocationField } from 'fields';
import { useField } from 'formik';
import { useLocalStorage } from 'hooks/useLocalStorage';
import { APP_PRODUCT_TYPE } from 'appConstants';

export default function OfficeLocation() {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails' });

  const [{ value: selectedOfficeLocation }, , { setValue }] = useField('officeLocation');

  const [, updateOfficeLocation] = useLocalStorage('cropOfficeLocation');

  const handleChange = useCallback(
    async (value) => {
      await setValue(value);

      updateOfficeLocation(value);
    },
    [updateOfficeLocation, setValue],
  );

  const resetValue = useCallback(async () => {
    await setValue('');
  }, [setValue]);

  return (
    <OfficeLocationField
      required
      productType={APP_PRODUCT_TYPE.CROP}
      name="officeLocation"
      label={t('labels.officeLocation')}
      placeholder={t('placeholders.officeLocation')}
      onChange={handleChange}
      resetValue={resetValue}
      selectedOfficeLocation={selectedOfficeLocation}
    />
  );
}
